var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFileIcone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.84583 15.8307C3.4625 15.8307 3.1425 15.7024 2.88583 15.4457C2.62861 15.1885 2.5 14.8682 2.5 14.4849V5.5099C2.5 5.12656 2.62861 4.80656 2.88583 4.5499C3.1425 4.29267 3.4625 4.16406 3.84583 4.16406H7.99667L9.66333 5.83073H16.1542C16.5375 5.83073 16.8575 5.95934 17.1142 6.21656C17.3714 6.47323 17.5 6.79323 17.5 7.17656V14.4849C17.5 14.8682 17.3717 15.1882 17.115 15.4449C16.8578 15.7021 16.5375 15.8307 16.1542 15.8307H3.84583Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileIcone);
export default __webpack_public_path__ + "static/media/FileIcone.a156dc1080789dcce7b5ba82ddec72bd.svg";
export { ForwardRef as ReactComponent };